import SplitScreen from './SplitScreen';

export default SplitScreen;
